import React, { createContext, useContext, useState, useEffect, useRef, useCallback } from 'react';

// API
import axios from 'axios';
import { apiUrl } from '../config/apiConfig';
import { fromZonedTime } from 'date-fns-tz';

import { useUser } from '../contexts/userContext';
import { useColumns } from '../contexts/columnsContext';

import api from "../../src/services/api"

const CRM_TIME_ZONE = 'America/Sao_Paulo';

const toCrmDateBoundaryIso = (date, endOfDay = false) => {
  const dateOnly = String(date).slice(0, 10);
  const time = endOfDay ? '23:59:59.999' : '00:00:00.000';
  return fromZonedTime(`${dateOnly}T${time}`, CRM_TIME_ZONE).toISOString();
};


const CardContext = createContext();

export const useCard = () => useContext(CardContext);

export const CardProvider = ({ children }) => {

  const { user } = useUser();

  const { buscaCombinadaComColuna, setBuscaCombinadaComColuna, filteredColumnsBuscaLocal, setFilteredColumnsBuscaLocal, columnsUser, setLoadingResult, setLoadingModal, dataInicial, setDataInicial, dataFinal, setDataFinal, dataType, tipoBuscaLocal, localSearchTerm, selectedAfilhados, showSharedCards, selectedEtiqueta, nivelBuscaCards, setNivelBuscaCards, orderBy, isAscending, selectedAnexoSetor, selectedTipoCliente } = useColumns();


  const [openCloseCreateCard, setOpenCloseCreateCard] = useState(false)
  const openModalCreateCard = () => setOpenCloseCreateCard(!openCloseCreateCard);
  const [listCardsFiltereds, setListCardsFiltereds] = useState([])
  const [searchTerm, setSearchTerm] = useState('');
  const [openCloseUpdateUserModal, setOpenCloseUpdateUserModal] = useState(false)
  const [currentCardData, setCurrentCardData] = useState()

  const [openCloseUpdateCard, setOpenCloseUpdateCard] = useState(false)

  const [cards, setCardsInternal] = useState([]);

  const [previewSearchCards, setPreviewSearchCards] = useState([]);

  const [listNotifications, setListNotifications] = useState([]);

  const [openCloseHistoricModal, setOpenCloseHistoricModal] = useState(false)
  const [openCloseTarefasModal, setOpenCloseTarefasModal] = useState(false)
  const [openCloseCompartilharModal, setOpenCloseCompartilharModal] = useState(false)
  const [openCloseModuloEsquadriasModal, setOpenCloseModuloEsquadriasModal] = useState(false)
  const [openCloseAnexosModal, setOpenCloseAnexosModal] = useState(false)

  const [openClosePedidosModal, setOpenClosePedidosModal] = useState(false)
  const [openCloseEmailModal, setOpenCloseEmailModal] = useState(false)
  const [openCloseDocumentosRelatoriosModal, setOpenCloseDocumentosRelatoriosModal] = useState(false)


  const [tarefas, setTarefas] = useState([]);

  const [currentCardIdMessage, setCurrentCardIdMessage] = useState(null)
  const [openCloseModalMessenger, setOpenCloseModalMessenger] = useState(false);



  const [currentModuleCard, setCurrentModuleCard] = useState()

  // Adicione este estado
  const [selectedTemperatures, setSelectedTemperatures] = useState([]);

  // ═══ NOVOS ESTADOS — Kanban Paginado ═══
  const [columnCards, setColumnCards] = useState({});
  // { [columnId]: { cards: [], page: 1, hasMore: true, totalCount: 0, totalValue: 0 } }
  const [columnSummaries, setColumnSummaries] = useState([]);
  // [{ column_id, count, total_value }]
  const [kanbanReady, setKanbanReady] = useState(false);

  // Ref para AbortController — cancela requests anteriores quando filtros mudam
  const abortControllerRef = useRef(null);
  // Geração da consulta atual — impede páginas antigas de contaminarem filtros novos
  const kanbanGenerationRef = useRef(0);
  // Ref para debounce de busca textual
  const searchDebounceRef = useRef(null);


  // ═══ setCards WRAPPER — redireciona mutações para columnCards ═══
  // Todas as chamadas existentes de setCards(prev => ...) continuam funcionando.
  // O useEffect derivador atualiza cards[] automaticamente a partir de columnCards.
  const setCards = useCallback((updater) => {
    if (typeof updater === 'function') {
      // Functional update: setCards(prevCards => prevCards.map(...))
      setColumnCards(prevColCards => {
        const allCards = Object.values(prevColCards).flatMap(c => c.cards || []);
        const newCards = updater(allCards);
        const newColCards = { ...prevColCards };
        for (const colId of Object.keys(newColCards)) {
          newColCards[colId] = {
            ...newColCards[colId],
            cards: newCards.filter(card => String(card.column_id) === String(colId)),
          };
        }
        return newColCards;
      });
    } else {
      // Direct value: setCards([...cards, newCard])
      setColumnCards(prevColCards => {
        const newColCards = { ...prevColCards };
        for (const colId of Object.keys(newColCards)) {
          newColCards[colId] = {
            ...newColCards[colId],
            cards: updater.filter(card => String(card.column_id) === String(colId)),
          };
        }
        return newColCards;
      });
    }
  }, []);



  // FILTRO DE BUSCA LOCAL

  const [listaCardsFiltrados, setListaCardsFiltrados] = useState([]);


  const addHistoricoCardContext = async (currentHistoric, cardId, userId) => {
    if (!currentHistoric || currentHistoric.trim() === '') return;

    try {
      const payload = {
        card_id: cardId,
        user_id: userId,
        action_type: 'Update',
        description: currentHistoric,
        empresa_id: user.empresa_id
      };

      await api.post(`/card/add-history`, payload);

    } catch (error) {
      console.error('Erro ao adicionar histórico ao card:', error);
    }
  };


  const addHistoricoCardSemUpdatedAtContext = async (currentHistoric, cardId, userId) => {
    if (!currentHistoric || currentHistoric.trim() === '') return;

    try {
      const payload = {
        card_id: cardId,
        user_id: userId,
        action_type: 'Update',
        description: currentHistoric,
        empresa_id: user.empresa_id
      };

      await api.post(`/card/add-history-no-updateat`, payload);

    } catch (error) {
      console.error('Erro ao adicionar histórico ao card:', error);
    }
  };


  // ═══════════════════════════════════════════════════════════════
  // Helper: monta os query params compartilhados por summaries e by-column
  // ═══════════════════════════════════════════════════════════════
  const buildFilterParams = useCallback(() => {
    const params = {
      dataInicial,
      dataFinal,
      dataType: dataType || 'created_at',
      nivelBusca: nivelBuscaCards,
      showSharedCards: showSharedCards ? 'true' : 'false',
    };
    if (selectedAfilhados && selectedAfilhados.length > 0) {
      params.selectedAfilhados = selectedAfilhados.join(',');
    }
    if (selectedEtiqueta) {
      params.selectedEtiqueta = String(selectedEtiqueta);
    }
    if (selectedTemperatures.length > 0) {
      params.selectedTemperatures = selectedTemperatures.join(',');
    }
    if (tipoBuscaLocal === 'vendidos') {
      params.statusFilter = 'vendidos';
    } else if (tipoBuscaLocal === 'perdidos') {
      params.statusFilter = 'perdidos';
    }
    if (localSearchTerm && localSearchTerm !== '' && tipoBuscaLocal &&
        !['vendidos', 'perdidos', 'temperatura'].includes(tipoBuscaLocal)) {
      params.tipoBuscaLocal = tipoBuscaLocal;
      params.localSearchTerm = localSearchTerm;
    }
    if (selectedAnexoSetor) {
      params.selectedAnexoSetor = selectedAnexoSetor;
    }
    if (selectedTipoCliente) {
      params.selectedTipoCliente = String(selectedTipoCliente);
    }
    return params;
  }, [dataInicial, dataFinal, dataType, nivelBuscaCards, selectedAfilhados, showSharedCards,
      selectedEtiqueta, tipoBuscaLocal, localSearchTerm, selectedTemperatures, selectedAnexoSetor,
      selectedTipoCliente]);


  // ═══════════════════════════════════════════════════════════════
  // Fetch Summaries (totalizadores de todas as colunas)
  // ═══════════════════════════════════════════════════════════════
  const fetchColumnSummaries = useCallback(async (signal) => {
    if (!user || !dataInicial || !dataFinal) return;
    try {
      const params = buildFilterParams();
      const response = await api.get(
        `/card/column-summaries/${user.id}/${user.empresa_id}`,
        { params, signal }
      );
      setColumnSummaries(response.data);
    } catch (error) {
      if (error.name !== 'CanceledError' && error.code !== 'ERR_CANCELED') {
        console.error('Erro ao buscar summaries:', error);
      }
    }
  }, [user, buildFilterParams]);

  // Exporta o conjunto completo usando a rota paginada já disponível no
  // servidor. O estado columnCards contém somente as páginas carregadas no
  // Kanban e não pode ser usado como fonte do Excel.
  const fetchAllFilteredCardsForExport = useCallback(async (filterOverrides = {}) => {
    if (!user || !dataInicial || !dataFinal || !columnsUser?.length) return [];

    const pageSize = 100;
    const baseParams = {
      ...buildFilterParams(),
      ...filterOverrides,
      dataInicial: toCrmDateBoundaryIso(dataInicial),
      dataFinal: toCrmDateBoundaryIso(dataFinal, true),
    };

    const cardsByColumn = await Promise.all(columnsUser.map(async (column) => {
      const cardsFromColumn = [];
      let page = 1;
      let totalPages = 1;

      do {
        const response = await api.get(
          `/card/by-column/${column.id}/${user.id}/${user.empresa_id}`,
          {
            params: {
              ...baseParams,
              orderBy: orderBy || 'dataCreate',
              isAscending: isAscending ? 'true' : 'false',
              page,
              limit: pageSize,
            },
          },
        );

        const data = response.data || {};
        cardsFromColumn.push(...(Array.isArray(data.cards) ? data.cards : []));
        totalPages = Math.max(1, Number(data.totalPages) || 1);
        page += 1;
      } while (page <= totalPages);

      return cardsFromColumn;
    }));

    const uniqueCards = new Map();
    cardsByColumn.flat().forEach(card => {
      if (card?.card_id != null) uniqueCards.set(String(card.card_id), card);
    });

    return Array.from(uniqueCards.values());
  }, [user, dataInicial, dataFinal, columnsUser, buildFilterParams, orderBy, isAscending]);


  // ═══════════════════════════════════════════════════════════════
  // Fetch Cards de uma coluna (paginado) — usado pelo scroll infinito
  // ═══════════════════════════════════════════════════════════════
  const fetchColumnCards = useCallback(async (columnId, page = 1, append = false, signal, requestGeneration) => {
    if (!user || !dataInicial || !dataFinal) return;
    const generation = requestGeneration ?? kanbanGenerationRef.current;
    try {
      const params = {
        ...buildFilterParams(),
        orderBy: orderBy || 'dataCreate',
        isAscending: isAscending ? 'true' : 'false',
        page,
        limit: 20,
      };
      const response = await api.get(
        `/card/by-column/${columnId}/${user.id}/${user.empresa_id}`,
        { params, signal }
      );
      if (generation !== kanbanGenerationRef.current) return;
      const data = response.data;
      setColumnCards(prev => {
        if (generation !== kanbanGenerationRef.current) return prev;
        const incomingCards = data.cards || [];
        const mergedCards = append
          ? [...(prev[columnId]?.cards || []), ...incomingCards]
          : incomingCards;
        const uniqueCards = Array.from(
          new Map(mergedCards.map(card => [String(card.card_id), card])).values()
        );

        return {
          ...prev,
          [columnId]: {
            cards: uniqueCards,
            page: data.page,
            hasMore: data.hasMore,
            totalCount: data.totalCount,
            totalValue: data.totalValue,
          }
        };
      });
    } catch (error) {
      if (error.name !== 'CanceledError' && error.code !== 'ERR_CANCELED') {
        console.error(`Erro ao buscar cards da coluna ${columnId}:`, error);
      }
    }
  }, [user, buildFilterParams, orderBy, isAscending]);


  // Expor fetchColumnCards para o Column/index.js usar no scroll
  const loadMoreColumnCards = useCallback(async (columnId) => {
    const current = columnCards[columnId];
    if (!current || !current.hasMore) return;
    const generation = kanbanGenerationRef.current;
    await fetchColumnCards(columnId, current.page + 1, true, undefined, generation);
  }, [columnCards, fetchColumnCards]);


  // ═══════════════════════════════════════════════════════════════
  // Carregamento principal do Kanban — UMA ÚNICA REQUEST (batch)
  // Retorna summaries + cards de todas as colunas numa só query SQL
  // ═══════════════════════════════════════════════════════════════
  const loadKanbanData = useCallback(async (columnsToLoad) => {
    if (!user || !dataInicial || !dataFinal || !columnsToLoad || columnsToLoad.length === 0) return;

    const generation = kanbanGenerationRef.current + 1;
    kanbanGenerationRef.current = generation;

    // Cancel previous in-flight requests
    if (abortControllerRef.current) {
      abortControllerRef.current.abort();
    }
    const controller = new AbortController();
    abortControllerRef.current = controller;

    try {
      // Spinner individual por coluna — não precisa do modal global
      setKanbanReady(false);
      setColumnCards({});
      setColumnSummaries([]);

      const params = {
        ...buildFilterParams(),
        columnIds: columnsToLoad.map(c => c.id).join(','),
        orderBy: orderBy || 'dataCreate',
        isAscending: isAscending ? 'true' : 'false',
        limit: 20,
      };

      const response = await api.get(
        `/card/kanban-batch/${user.id}/${user.empresa_id}`,
        { params, signal: controller.signal }
      );

      if (generation !== kanbanGenerationRef.current) return;

      const { summaries, columns: colData } = response.data;
      setColumnSummaries(summaries || []);
      setColumnCards(colData || {});
      setKanbanReady(true);
    } catch (error) {
      if (error.name !== 'CanceledError' && error.code !== 'ERR_CANCELED') {
        console.error('Erro ao carregar kanban:', error);
        if (generation === kanbanGenerationRef.current) {
          setKanbanReady(true);
        }
      }
    }
  }, [user, dataInicial, dataFinal, buildFilterParams, orderBy, isAscending]);

  // ═══════════════════════════════════════════════════════════════
  // Keep legacy fetchCards for components that still call it directly
  // ═══════════════════════════════════════════════════════════════
  const fetchCards = useCallback(async (dataInicialParam, dataFinalParam, dataType = 'created_at') => {
    // Carrega somente as colunas explicitamente liberadas para o usuário.
    if (columnsUser && columnsUser.length > 0) {
      await loadKanbanData(columnsUser);
    }
  }, [columnsUser, loadKanbanData]);


  // ═══════════════════════════════════════════════════════════════
  // INITIAL LOAD — quando user muda ou nivelBusca muda
  // ═══════════════════════════════════════════════════════════════
  useEffect(() => {
    if (!user) return;
    const today = new Date();
    const endOfToday = new Date(today.getFullYear(), today.getMonth(), today.getDate(), 23, 59, 59);
    const fiveYearsAgo = new Date(today.getFullYear() - 5, today.getMonth(), today.getDate());

    setDataInicial(fiveYearsAgo.toISOString().split('T')[0]);
    setDataFinal(endOfToday.toISOString().split('T')[0]);
  }, [user]);


  // ═══════════════════════════════════════════════════════════════
  // RELOAD — quando colunas ficam disponíveis ou filtros mudam
  // ═══════════════════════════════════════════════════════════════
  useEffect(() => {
    if (!user || !columnsUser || columnsUser.length === 0 || !dataInicial || !dataFinal) return;

    // For text search, use debounce to avoid excessive requests
    if (localSearchTerm && localSearchTerm !== '') {
      if (searchDebounceRef.current) clearTimeout(searchDebounceRef.current);
      searchDebounceRef.current = setTimeout(() => {
        loadKanbanData(columnsUser);
      }, 350);
      return () => {
        if (searchDebounceRef.current) clearTimeout(searchDebounceRef.current);
      };
    }

    loadKanbanData(columnsUser);
  }, [user, columnsUser, dataInicial, dataFinal, dataType, nivelBuscaCards,
      selectedAfilhados, showSharedCards, selectedEtiqueta,
      tipoBuscaLocal, localSearchTerm, selectedTemperatures,
      orderBy, isAscending, selectedAnexoSetor, selectedTipoCliente]);


  // ═══════════════════════════════════════════════════════════════
  // DERIVAR cards[] e listaCardsFiltrados[] para backward compat
  // (componentes como Mapa, Export Excel, etc. continuam funcionando)
  // ═══════════════════════════════════════════════════════════════
  useEffect(() => {
    const allCards = Object.values(columnCards).flatMap(col => col.cards || []);
    setCardsInternal(allCards);
    setListaCardsFiltrados(allCards);

    // Update filteredColumnsBuscaLocal based on which columns have cards
    if (buscaCombinadaComColuna) {
      const colIdsWithCards = new Set(allCards.map(c => c.column_id));
      const filtered = columnsUser.filter(col => colIdsWithCards.has(col.id));
      setFilteredColumnsBuscaLocal(filtered);
    } else {
      setFilteredColumnsBuscaLocal(columnsUser);
    }
  }, [columnCards, columnsUser, buscaCombinadaComColuna, localSearchTerm, tipoBuscaLocal]);


// Função para alternar a seleção de temperatura
const toggleTemperatureSelection = (temperature) => {
  setSelectedTemperatures((prev) => {
    return prev.includes(temperature)
      ? prev.filter(temp => temp !== temperature)
      : [...prev, temperature];
  });
};





  const contextValue = {
    openCloseCreateCard,
    openModalCreateCard,
    listCardsFiltereds, setListCardsFiltereds,
    searchTerm, setSearchTerm,
    currentCardData, setCurrentCardData,
    openCloseUpdateCard, setOpenCloseUpdateCard,
    cards, setCards,
    previewSearchCards, setPreviewSearchCards,
    listNotifications, setListNotifications,
    openCloseHistoricModal, setOpenCloseHistoricModal,
    openCloseTarefasModal, setOpenCloseTarefasModal,
    openCloseCompartilharModal, setOpenCloseCompartilharModal,
    tarefas, setTarefas,
    openCloseModuloEsquadriasModal, setOpenCloseModuloEsquadriasModal,
    addHistoricoCardContext,
    currentCardIdMessage, setCurrentCardIdMessage,
    openCloseModalMessenger, setOpenCloseModalMessenger,
    openCloseAnexosModal, setOpenCloseAnexosModal,
    fetchCards,
    currentModuleCard, setCurrentModuleCard,
    openClosePedidosModal, setOpenClosePedidosModal,
    openCloseEmailModal, setOpenCloseEmailModal,
    openCloseDocumentosRelatoriosModal, setOpenCloseDocumentosRelatoriosModal,
    listaCardsFiltrados, setListaCardsFiltrados,
    addHistoricoCardSemUpdatedAtContext,
    selectedTemperatures, setSelectedTemperatures,
    toggleTemperatureSelection,
    columnCards, setColumnCards,
    columnSummaries,
    fetchColumnCards,
    fetchColumnSummaries,
    fetchAllFilteredCardsForExport,
    loadMoreColumnCards,
    loadKanbanData,
    kanbanReady,
  };

  return (
    <CardContext.Provider value={contextValue}>
      {children}
    </CardContext.Provider>
  );
};
